import React from 'react';
import styles from './document-download.module.scss';
import {useTranslation} from "react-i18next";

interface DocumentItemProps {
  filename: string;
  onDownload: () => void;
  showDownloadButton?: boolean;
}

const DocumentDownloadItem: React.FC<DocumentItemProps> = ({ filename, onDownload, showDownloadButton = false }) => {
  const {t} = useTranslation();

  return (
    <div onClick={onDownload}  className={`${styles.documentItem} ${showDownloadButton ? styles.withButton : ''}`}>
      <a className={`${styles.filename} ${showDownloadButton ? styles.withButton : ''}`}>
        <div className={styles.iconFilename}></div>
        {filename}
      </a>
      {showDownloadButton && (
        <button className={styles.downloadButton}>
            {t('download-button.button')}
          <div className={styles.icon}></div>
        </button>
      )}
    </div>
  );
};

export default DocumentDownloadItem;
